<script setup lang="ts">
import type { Selectable } from '@/components/selectBox/selectBox';

import { ButtonSize } from '@/hooks/useButtonClasses';

import Button from '@/components/button/Button.vue';
import FormListboxInput from '@/components/formListboxInput/FormListboxInput.vue';
import FormRows from '@/components/formRows/FormRows.vue';
import FormTextInput from '@/components/formTextInput/FormTextInput.vue';

import AbstractTriangle from '@/images/abstract-triangle.svg';

export type CreateAccountTwoFactorChannelProps = {
  channelTypes: App.Base.Data.EnumData[];
};

const props = defineProps<CreateAccountTwoFactorChannelProps>();

const form = useForm({
  method: 'POST',
  url: route('student.two-factor.setup.store'),
  fields: {
    type: props.channelTypes?.filter((type) => type.value === 'sms')[0],
    destination: ''
  },
  transform: (fields) => ({
    ...fields,
    type: fields.type?.value
  })
});

const isSms = computed(() => form.fields.type.value === 'sms');

function handleTypeChange(value: Selectable<string> | null) {
  form.fields.type = value as Selectable<string>;
  form.fields.destination = '';
}
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/domains/auth/layouts/two-columns-guest.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
  <div class="flex flex-col gap-y-6">
    <div class="flex items-center justify-between">
      <div class="flex flex-col gap-2">
        <h1 class="text-left text-2xl font-semibold leading-9 text-slate-900 sm:text-3xl">
          Two-factor authentication
        </h1>
        <p class="text-md leading-relaxed text-slate-700">
          Select a device type and enter your phone number or email address to receive a
          verification code.
        </p>
      </div>
      <AbstractTriangle class="h-18 w-18" />
    </div>
    <form class="flex flex-col gap-y-8" @submit.prevent="form.submit">
      <FormRows>
        <FormListboxInput
          label="Device type"
          name="type"
          :options="channelTypes ?? []"
          :error="form.errors.type as string"
          :modelValue="form.fields.type"
          @update:modelValue="handleTypeChange"
        />
        <FormTextInput
          required
          :label="isSms ? 'Phone number' : 'Email address'"
          :placeholder="isSms ? 'Enter your phone number' : 'Enter your email address'"
          name="destination"
          :type="isSms ? 'tel' : 'email'"
          :error="form.errors.destination"
          :modelValue="form.fields.destination"
          @update:modelValue="(value) => (form.fields.destination = value as string)"
        />
      </FormRows>
      <div class="flex flex-col">
        <Button
          :isDisabled="!form.fields.destination || form.processing"
          :size="ButtonSize.lg"
          :isLoading="form.processing"
          type="submit"
          useMediaQuery
        >
          Send verification code
        </Button>
      </div>
    </form>
  </div>
</template>
